export const sidebarConfig = {
    url: 'pages/menu',
    sufix: '-menu'
}

